import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LIB_CONFIG } from '../lib-config';
import { LibConfig } from '../models/lib-config.model';
import { HandshakeService } from '../services/handshake.service';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { environment } from '../../../../../apps/content/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FindByIpService {
  constructor(
    private http: HttpClient,
    private handshakeService: HandshakeService,
    @Inject(LIB_CONFIG) private config: LibConfig
  ) {}

  findByIp(ipAddress: string): Observable<any> {
    if (environment.envName !== 'prod') {
      return of(null);
    } else {
      return this.handshakeService.getAuthorizationHeaders().pipe(
        mergeMap((authorizationHeaders: any) => {
          const { findByIp } = this.config.compaxAngularApi;
          return this.http.post(`${this.config?.apigeeApi?.baseUrl}${findByIp}`, { ipAddress }, authorizationHeaders);
        })
      );
    }
  }
}
